module.exports = __webpack_public_path__ + "img/wx.573e0ace.png";